import { motion, useReducedMotion } from 'motion/react';

export default function IconButton({
  children,
  onClick,
  disabled = false,
  danger = false,
  className = '',
  title,
  ...rest
}) {
  const reduceMotion = useReducedMotion();
  const cls = ['aui-icon-btn', danger ? 'danger' : '', className].filter(Boolean).join(' ');

  return (
    <motion.button
      type="button"
      className={cls}
      disabled={disabled}
      onClick={onClick}
      title={title}
      whileTap={reduceMotion ? undefined : { scale: 0.93 }}
      {...rest}
    >
      {children}
    </motion.button>
  );
}
